<template>
  <v-card
    class="d-flex justify-space-around pa-2 ma-0"
    :class="[{ 'row mx-4': $vuetify.breakpoint.smAndDown }]"
    flat
  >
    <v-card
      class="group-card rectangle pa-0"
      v-for="(item, i) in accidentgroup"
      :key="i"
      :class="[
        { 'ml-3': i != 0 && $vuetify.breakpoint.mdAndUp },
        { 'col-12 mb-4': $vuetify.breakpoint.smAndDown }
      ]"
    >
      <div class="numrow py-1">
        <div class="numheader">{{ item.id }}</div>
      </div>
      <div class="groupheader my-1">
        <p class="ma-0 pa-0">{{ item.name }}</p>
      </div>
      <div>
        <!-- <div class="outline-menu">
          <v-img class="menu" :src="item.icon"></v-img>
        </div> -->
      </div>
      <div class="stat">
        <p class="font-weight-medium my-0 headline number">{{ item.accident | numFormat }}</p>
        <p class="subtitle-2 my-0">ครั้ง</p>
      </div>
      <v-row class="ma-0">
        <v-col cols="6" class="pa-0">
          <div class="text-center">
            <v-img
              contain
              height="32"
              :src="require('@/assets/icons/death.svg')"
              class="ma-0 mt-2"
            ></v-img>
            <!-- <i :class="`fas fa-dizzy fa-2x`" class="ma-0 mt-2"></i> -->
          </div>
          <p class="title my-0">{{ item.dead | numFormat }}</p>
          <p class="subtitle-2 my-0">คน</p>
        </v-col>
        <v-col cols="6" class="pa-0">
          <div class="text-center">
            <i :class="`fas fa-user-injured fa-2x`" class="ma-0 mt-2"></i>
          </div>
          <p class="title my-0">{{ item.injury | numFormat }}</p>
          <p class="subtitle-2 my-0">คน</p>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'AccidentGroup',
  props: {
    searchCondition: {
      type: Object
    }
  },
  data: () => ({
    accidentgroup: [
      // { id: int,name : 'string', accident: int, dead: int, injury: int},
    ]
  }),
  mounted() {
    this.getAccidentWaterGroup();
  },
  methods: {
    getAccidentWaterGroup() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/category/water`;

      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.accidentgroup = response.data.data;
          }
        })
        .catch(function(error) {
          scope.accidentgroup = [];
          console.log(error);
        });
    }
  },
  watch: {
    searchCondition() {
      this.getAccidentWaterGroup();
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  display: grid;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}

.col .img {
  padding: 0;
}
.groupheader {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: lightgray;
  font-size: 15px;
  height: 72px;
}
.card {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  margin-top: 15px;
}

.stat {
  background-color: white;
  margin: auto;
}

.number {
  color: #ba4438;
  text-align: center;
}

p {
  text-align: center;
}

.outline-menu {
  height: 100%;
  text-align: center;
}

.menu {
  width: 48px;
  height: 48px;
  margin: auto;
  top: calc(50% - 24px);
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}
.numrow {
  display: flex;
  justify-content: center;
}
.numheader {
  text-align: center;
  font-size: 32px;
  background-color: darkgray;
  color: white;
  border-radius: 50%;
  width: 48px;
}
.rectangle {
  // width: 180px;
  height: 240px;
  border-radius: 3px;
  border: solid 1px #979797;
}
.group-card {
  height: auto;
  width: 115px;
}</style
>>
